<template>
  <main :class="$options.name">
    <Head
      :title="$options.name + ' | Nice Bike'"
      description="We are a family owned small bicycle shop that is dedicated to bringing you the absolute best in cycling. We are Nice Bike."
      keywords="nice bike"
      :image="page.length ? 'https:' + page.hero.fields.file.url + '?fm=jpg&fl=progressive&fit=fill&w=1200&h=630':'https://ridenicebike.com/img/social.jpg'"
      url="https://ridenicebike.com/about"
    />
    <Loader v-if="loading"/>
    <Hero v-if="!errored && !loading && page.hero.fields" :img="page.hero.fields.file.url">
      <RichText :value="page.heroText"/>
    </Hero>
    <article v-if="!errored && !loading">
      <RichText
        :class="[
          $options.name + '__content',
          'innerWrap'
        ]"
        :value="page.content"
      />
      <section v-if="crew.length" :class="$options.name + '__crew'">
        <header class="innerWrap">
          <h2>Our crew</h2>
        </header>
        <CrewMember
          v-for="member in crew"
          :key="member.sys.id"
          :description="member.fields.description"
          :email="member.fields.email"
          :images="member.fields.images"
          :phone="member.fields.phone"
          :subtitle="member.fields.subtitle"
          :title="member.fields.title"
        />
      </section>
      <section
        id="testimonials"
        :class="[
          $options.name + '__testimonials',
          'innerWrap'
        ]"
      >
        <Testimonials/>
      </section>
    </article>
  </main>
</template>
<script>
import CrewMember from "@/components/CrewMember";
import Hero from "@/components/Hero";
import Loader from "@/components/Loader";
import RichText from "@/components/RichText";
import Testimonials from "@/components/Testimonials";
export default {
  name: "About",
  components: { CrewMember, Hero, Loader, RichText, Testimonials },
  data() {
    return {
      apiSpace: this.$store.state.apiSpace,
      apiToken: this.$store.state.apiToken,
      crew: [],
      errored: false,
      loading: true,
      page: []
    };
  },
  methods: {
    getAbout() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntry("2RtDMdAYapSZzmBd4Knt0P")
        .then(entry => {
          this.page = entry.fields;
        })
        .catch(error => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getCrew() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntries({
          content_type: "crew",
          order: "fields.sort"
        })
        .then(entries => {
          this.crew = entries.items;
        })
        .catch(error => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    }
  },
  mounted() {
    this.getAbout();
    this.getCrew();
  }
};
</script>
<style lang="scss">
.About {
  &__content {
    h2 {
      color: var(--base-mid);
      margin-top: rem(48);
    }
  }
  &__crew {
    > header {
      text-align: center;
    }
    h2 {
      color: var(--base-mid);
      margin-top: rem(32);
    }
  }
  &__content,
  &__testimonials {
    > * + * {
      margin-top: rem(16);
    }
  }
}
</style>